<template>
	<svg
		width="344"
		height="344"
		viewBox="0 0 344 344"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M1.56633e-06 86.0067C2.08537e-06 38.5099 38.5037 0.00612385 86.0005 0.00612385V225.901C86.0005 243.633 100.375 258.008 118.107 258.008H258.001C258.001 305.505 219.498 344.008 172.001 344.008H114.667C51.3383 344.008 -6.9205e-07 292.67 0 229.341L1.56633e-06 86.0067Z"
			fill="#9250E9"
		/>
		<path
			d="M344 258.002C344 305.499 305.496 344.002 258 344.002L257.999 118.107C257.999 100.375 243.625 86.0006 225.893 86.0006L85.9985 86.0006C85.9985 38.5038 124.502 9.16457e-06 171.999 5.01227e-06L229.333 0C292.662 -5.5364e-06 344 51.3384 344 114.667L344 258.002Z"
			fill="#9250E9"
		/>
		<path
			d="M217.864 172.001C217.864 197.333 197.329 217.868 171.997 217.868L126.13 217.868V172.001C126.13 146.67 146.665 126.134 171.997 126.134H217.864L217.864 172.001Z"
			fill="#9250E9"
		/>
	</svg>
</template>
